var chunkMapping = {
	"71": [
		40071
	],
	"79": [
		19079
	],
	"125": [
		16125
	],
	"137": [
		35137
	],
	"182": [
		95182
	],
	"232": [
		26232
	],
	"383": [
		35383
	],
	"417": [
		417
	],
	"556": [
		56085,
		60667,
		98707
	],
	"635": [
		50635
	],
	"806": [
		46806
	],
	"810": [
		28810
	],
	"811": [
		76811
	]
};
var idToExternalAndNameMapping = {
	"417": [
		"default",
		"./Commerce",
		49336
	],
	"16125": [
		"default",
		"./Files",
		49336
	],
	"19079": [
		"default",
		"./DataTypeSettings",
		49336
	],
	"26232": [
		"default",
		"./Summary",
		49336
	],
	"28810": [
		"default",
		"./UserManagement",
		78676
	],
	"35137": [
		"default",
		"./App",
		49336
	],
	"35383": [
		"default",
		"./Deprecations",
		78676
	],
	"40071": [
		"default",
		"./App",
		47659
	],
	"46806": [
		"default",
		"./Banking",
		49336
	],
	"50635": [
		"default",
		"./Accounting",
		49336
	],
	"56085": [
		"default",
		"./IntegrationPageNameContext",
		18077
	],
	"60667": [
		"default",
		"./UserStateContext",
		18077
	],
	"76811": [
		"default",
		"./App",
		78676
	],
	"95182": [
		"default",
		"./App",
		72209
	],
	"98707": [
		"default",
		"./FeatureStatusContext",
		18077
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}